import styled from 'styled-components';
import { colors } from '@/styles';

export const Editor = styled.div<{ $hasError: boolean; $readOnly?: boolean }>`
  display: flex;
  flex-direction: column;
  gap: 1rem;
  /* border: ${(props) => (props.$readOnly ? '1px solid lime' : 'none')}; */

  .ace_comment.ace_placeholder {
    color: ${colors.secondary.mediumGray};
    font-size: 14px;
    font-family: monospace;
    padding: 10px !important;
    z-index: auto !important;
  }

  .prompt-input {
    border-width: 1px;
    border-style: solid;
    background-color: ${(props) => (props.$readOnly ? colors.secondary.lightGray1 : 'white')};
    border-color: ${(props) => (props.$hasError ? colors.semantic.negative.primary : colors.secondary.lightGray3)};
    border-radius: 5px;
    overflow: hidden;
    & > * {
      cursor: ${(props) => (props.$readOnly ? 'not-allowed' : 'inherit')};
      opacity: ${(props) => (props.$readOnly ? 0.7 : 1)};
    }
  }
`;

export const PromptDisplay = styled.pre`
  flex: 1;
  min-height: 50px;
  max-height: 250px;
  border: 1px solid ${colors.secondary.lightGray3};
  background-color: ${colors.secondary.lightGray1};
  border-radius: 5px;
  line-height: 1.5;
  font-family: monospace;
  padding: 10px;
  overflow-y: auto;
`;
